<template>
    <div>
        <b-modal id="modal-Events" class="modal-form" title="Add Events" @hidden="formevent.title = ''" centered hide-footer>
            <ValidationObserver ref="form">
                <validation-provider rules="required" v-slot="{ errors }">
                    <div class="form-group">
                        <label>Event Name</label>
                        <input v-model="formevent.title" type="text" class="form-control" name="name">
                        <div class="invalid-input">{{ errors[0] }}</div>
                    </div>
                </validation-provider>

                <validation-provider rules="required" v-slot="{ errors }">
                    <div class="form-group">
                        <label>Event Date</label>
                        <datetime v-model="formevent.date" zone='local' value-zone='local' type="date" input-class="form-control"></datetime>
                        <div class="invalid-input">{{ errors[0] }}</div>
                    </div>
                </validation-provider>

                <label>Choose Package</label>

                <div class="row-style row-style-pck">
                    <div class="style" @click="formevent.package = 'STANDARD'" :class="formevent.package === 'STANDARD' ? 'active' : ''">
                        <div class="style-item style-img">
                            <div class="style-tx">
                                <div class="w-100">
                                    STANDART
                                    <span>1 Slot</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="style"  @click="formevent.package = 'PREMIUM'" :class="formevent.package === 'PREMIUM' ? 'active' : ''">
                        <div class="style-item style-img">
                            <div class="style-tx">
                                <div class="w-100">
                                    PREMIUM
                                    <span>2 Slot</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="style"></div>
                    <div class="style"></div>
                </div>

                <div class="mt-3">
                    <a href="#" v-if="show_feature === false" @click.prevent="show_feature = true">Show Detail Package</a>
                    <a href="#" v-if="show_feature === true" @click.prevent="show_feature = false">Hide Detail Package</a>
                </div>

                <div class="list mt-4" v-if="show_feature === true">
                    <div class="package">
                        <div class="table-responsive">
                            <table class="table table-bordered">
                                <tr>
                                    <th>Fatures</th>
                                    <th>STANDARD</th>
                                    <th>PREMIUM</th>
                                </tr>
                                <tbody>
                                    <tr>
                                        <td>Person</td>
                                        <td>Max 2</td>
                                        <td>Unlimited</td>
                                    </tr>
                                    <tr>
                                        <td>Gallery</td>
                                        <td>Max 8</td>
                                        <td>Unlimited</td>
                                    </tr>
                                    <tr>
                                        <td>Video</td>
                                        <td>Max 1</td>
                                        <td>Unlimited</td>
                                    </tr>
                                    <tr>
                                        <td>Schedule</td>
                                        <td>Max 1</td>
                                        <td>Unlimited</td>
                                    </tr>
                                    <tr>
                                        <td>Story</td>
                                        <td>Disabled</td>
                                        <td>Active</td>
                                    </tr>
                                    <tr>
                                        <td>Change Background Color</td>
                                        <td>Disabled</td>
                                        <td>Active</td>
                                    </tr>
                                    <tr>
                                        <td>Change Text Color</td>
                                        <td>Disabled</td>
                                        <td>Active</td>
                                    </tr>
                                    <tr>
                                        <td>Change Language</td>
                                        <td>Disabled (default language indonesia)</td>
                                        <td>Active</td>
                                    </tr>
                                    <tr>
                                        <td>RSVP</td>
                                        <td>Disabled</td>
                                        <td>Active</td>
                                    </tr>
                                    <tr>
                                        <td>Digital Gift</td>
                                        <td>Disabled</td>
                                        <td>Active</td>
                                    </tr>
                                    <tr>
                                        <td>QR Code</td>
                                        <td>Disabled</td>
                                        <td>Active</td>
                                    </tr>
                                    <tr>
                                        <td>Save Google Calendar</td>
                                        <td>Disabled</td>
                                        <td>Active</td>
                                    </tr>
                                    <tr>
                                        <td>Live Streaming</td>
                                        <td>Disabled</td>
                                        <td>Active</td>
                                    </tr>
                                    <tr>
                                        <td>Album Photo</td>
                                        <td>Disabled</td>
                                        <td>Active</td>
                                    </tr>
                                    <tr>
                                        <td>Report Analytics</td>
                                        <td>Disabled</td>
                                        <td>Active</td>
                                    </tr>
                                    <tr>
                                        <td>Navigation</td>
                                        <td>Disabled</td>
                                        <td>Active</td>
                                    </tr>
                                    <tr>
                                        <td>Custom Event</td>
                                        <td>No</td>
                                        <td>Yes</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>

                <div class="button-modal text-right">
                    <button v-on:click="validationForm()" type="button" class="btn btn-new" v-bind:class="loading ? 'btn-progress' : ''">
                        Save Data
                    </button>
                </div>
            </ValidationObserver>
        </b-modal>
    </div>
</template>

<script>
    import { mapState, mapActions} from 'vuex'
    import {ValidationProvider, ValidationObserver} from "vee-validate";
    import { Datetime } from 'vue-datetime';

    export default{
        data(){
            return{
                loading:false,
                show_feature:false,
            }
        },
        components: {
            ValidationProvider,
            ValidationObserver,
            Datetime,
        },
        computed: {
            ...mapState('EventsControl', {
                formevent: state => state.formevent,
                errors: state => state.errors
            }),
        },
        methods: {
            ...mapActions('EventsControl', ['createEvents']),
            ...mapActions('UsersControl', ['getProfile']),

            validationForm: function() {
                this.$refs.form.validate().then(success => {
                    if (!success) {
                        setTimeout(() => {
                            const errors = Object.entries(this.$refs.form.errors)
                                .map(([key, value]) => ({ key, value }))
                                .filter(error => error["value"].length);
                            this.$refs.form.refs[errors[0]["key"]].$el.scrollIntoView({
                                behavior: "smooth",
                                block: "center"
                            });
                        }, 100);
                    }else{
                        this.loading = true

                        this.createEvents().then(() => {
                            this.loading = false
                            this.$bvModal.hide('modal-Events')
                            this.$emit('getEvents');
                            this.getProfile()
                            this.$toast.success('Successfully Added Event, Please click your event below to setup your event')
                        })
                        .catch((error) => {
                            console.log(error)
                            this.loading = false
                            if(error.response.data.errors == 'slot'){
                                this.$toast.warning('Your slots are not enough')
                            }else{
                                this.$toast.warning('Sorry, Something Error')
                            }
                        })
                    }
                });
            },
        }
    }
</script>
